import { render, staticRenderFns } from "./dataBaseSon.vue?vue&type=template&id=87184c22&scoped=true&"
import script from "./dataBaseSon.vue?vue&type=script&lang=js&"
export * from "./dataBaseSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87184c22",
  null
  
)

export default component.exports